import { Commodity } from '@portal/shared/types/commodity.types';
import { DeviceForAPI } from 'src/app/services/data/devices-data/devices-data.types';
import { ExportRow } from '@portal/shared/types/export.types';
import { devicesWithoutSerialNumber } from '../../constants/devices.constants';

export const mapMeteringMeterToExport = (meter: DeviceForAPI, formatDate: (date: string) => string): ExportRow => {
  const accountNumbers =
    meter.servicePoints
      ?.map(sp => sp.fullAccountNumber)
      .filter(Boolean)
      .join('; ') ?? '';
  const serviceLocationIds =
    meter.servicePoints
      ?.map(sp => (sp.serviceLocationId ? `${sp.serviceLocationId}` : null))
      .filter(Boolean)
      .join('; ') ?? '';

  return {
    commDeviceId: { title: 'CommDeviceID', value: meter.commDeviceId ?? meter.parentCommDeviceId ?? '' },
    serialNumber: {
      title: 'SerialNumber',
      value: devicesWithoutSerialNumber.includes(meter.deviceType)
        ? ''
        : (meter.serialNumber ?? 'Unknown Serial Number')
    },
    deviceTypeName: { title: 'DeviceType', value: meter.deviceTypeName },
    meterNumber: { title: 'InventoryID', value: meter.meterNumber ?? '' },
    accountNumbers: { title: 'AccountNumber', value: accountNumbers },
    serviceLocationIds: { title: 'ServiceLocationNumber', value: serviceLocationIds },
    commodity: {
      title: 'Commodity',
      value: meter.commodity === Commodity.Electricity ? 'Electric' : meter.commodity
    },
    portNumber: { title: 'Port', value: meter.portNumber },
    model: { title: 'Model', value: meter.model },
    status: { title: 'Status', value: meter.status },
    deviceStatusValue: { title: 'DeviceHealth', value: meter.deviceStatusValue },
    lastHeard: { title: 'LastHeard', value: meter.lastHeard ? formatDate(meter.lastHeard) : '' },
    batteryStatus: { title: 'BatteryStatus', value: meter.batteryStatus },
    transmissionReadRateStatus: { title: 'ReadRateStatus', value: meter.transmissionReadRateStatus },
    validTransmissionReadRateStatus: {
      title: 'ValidReadRateStatus',
      value: meter.validTransmissionReadRateStatus
    },
    serviceLocationAddress: {
      title: 'ServiceLocationAddress',
      value:
        meter.servicePoints
          ?.map(sp => sp.serviceLocationAddress ?? '')
          .filter(Boolean)
          .join('; ') ?? ''
    },
    location: [
      { title: 'Latitude', value: meter.geoMetaData?.latitude ?? '' },
      { title: 'Longitude', value: meter.geoMetaData?.longitude ?? '' },
      { title: 'Comment', value: meter.geoMetaData?.comments ?? '' }
    ]
  } as ExportRow;
};
